var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.shouldShowMessage
    ? _c(
        "div",
        { staticClass: "notification-container" },
        [
          _c(_setup.FontAwesomeIcon, { attrs: { icon: ["fas", "fa-key"] } }),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("b", [_vm._v("API Key Needed:")]),
      _vm._v(
        " This image effect requires an API Key. Please set it up in\n        "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "/account/integrations",
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [_vm._v("Account Integrations")]
      ),
      _vm._v("\n        if you haven't done so already.\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }